import { useRequestMutation } from "hooks/useRequest";
import { DownloadType, DownloadTypeEnum } from "models/AiResearch";
import { useEffect } from "react";

export const useDownload = () => {
  const { data, trigger: triggerDownload } = useRequestMutation<string>(
    "/sse/query/rag/download"
  );

  // 回答ダウンロード処理
  const onDownload = ({
    questionId,
    type
  }: {
    type: DownloadType;
    questionId: string;
  }) => {
    triggerDownload({
      questionId: questionId,
      downloadType:
        type === "pdf"
          ? DownloadTypeEnum.PDF
          : type === "docx"
          ? DownloadTypeEnum.DOCX
          : DownloadTypeEnum.MD
    });
  };

  useEffect(() => {
    if (!data) return;

    location.href = data;
  }, [data]);

  return { onDownload };
};
